import React from 'react'

const TitleHeader = ({ Icon, title1, title2, subtext, iconAlt = "" }) => {
    const isImageIcon = typeof Icon === "string";

    return (
        <div className="d-a gap-3 flex-fill">
            {isImageIcon ? (
                <span
                    className="wf-icon-blue text-white bg-primary fw-bold p-2 landing-page-main-icon d-j-a"
                    style={{ height: "40px", width: "40px" }}
                >
                    <img
                        src={Icon}
                        alt={iconAlt}
                        style={{ height: "100%", width: "100%", objectFit: "contain", filter: "brightness(0) invert(1)" }}
                    />
                </span>
            ) : (
                <Icon
                    className="wf-icon-blue text-white bg-primary fw-bold p-2 landing-page-main-icon"
                    style={{ height: "40px", width: "40px" }}
                />
            )}
            <div className="title-header__copy">
                <h4 className="header-tag-projects projects-width m-0 text-center title-header__heading">
                    {title1 ? `${title1} ` : ""}
                    <strong className="search-icon">{title2}</strong>
                </h4>
                <span className=" sub-gray-text ">
                    {subtext}
                </span>
            </div>
        </div>
    )
}

export default TitleHeader
